import React from 'react';
import classNames from 'classnames';

import Select from '../../components/select';
import TranslationIds from '../../../commons/translationIds';

function renderCustomDropdown (p) {
    const {
        classes,
        // customFields,
        customValues,
        updateCustomValues,
        item,
        fieldErrors,
        translateWithValues,
    } = p;


    function getValue () {
        if (!customValues[item.name]) {
            return '-';
        }
        return customValues[item.name];
    }

    function getDataProvider () {
        if (item?.value?.length <= 0) {
            return [];
        }

        if (!customValues[item.name]) {
            const values = item?.value.map((v) => {
                return {
                    value: v,
                    label: v,
                    code: v,
                };
            });

            return [
                {
                    value: '-',
                    label: getHelperText(),
                    code: '',
                },
                ...values,
            ];
        }

        return item?.value.map((v) => {
            return {
                value: v,
                label: v,
                code: v,
            };
        });
    }

    function getHelperText () {
        if (item.required) {
            return `${item.name}*`;
        }
        return item.name;
    }

    function getErrorText () {
        if (fieldErrors[item.name]) {
            return translateWithValues(TranslationIds.REGISTRATION_REQUIRED_FIELD, { label: item.name });
        }
        return '';
    }

    return (
        <Select
            className={classNames(['ecal-reg-field-custom-field-dropdown', classes.selectUI])}
            placeHolder={getHelperText()}
            helperText={getErrorText()}
            labelHeading={getHelperText()}
            value={getValue()}
            dataProvider={getDataProvider()}
            error={fieldErrors[item.name]}
            onChange={(e, value) => {
                updateCustomValues({
                    [item.name]: value,
                });
            }}
            name={item.name}
           
        />
    );
}

export default renderCustomDropdown;